import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Header } from './Header'
import { Footer } from './Footer'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="skip-link"
      >
        {t('aria.skipToContent', 'Vai al contenuto principale')}
      </a>
      <Header />
      <main id="main-content" className="flex-1 pt-20">
        {children}
      </main>
      <Footer />
    </div>
  )
}
